import Icon from '@/components/ui/AppIcon';

interface Step {
  icon: string;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    icon: 'DevicePhoneMobileIcon',
    title: 'Instagram folgen',
    description: 'Folge @copterstories auf Instagram und werde Teil der Community.',
  },
  {
    icon: 'EnvelopeIcon',
    title: 'Code erhalten',
    description: 'Halte Ausschau nach einem 8-stelligen Zugangscode.',
  },
  {
    icon: 'MapIcon',
    title: 'Karte erkunden',
    description: 'Entdecke und teile verlassene Orte auf der interaktiven Karte.',
  },
];

export default function InstructionSteps() {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 mb-4">
        <div className="h-px flex-1 bg-white/5" />
        <span className="font-mono text-xs text-muted-foreground/50 uppercase tracking-widest px-2">
          Wie es funktioniert
        </span>
        <div className="h-px flex-1 bg-white/5" />
      </div>
      <div className="grid grid-cols-3 gap-3">
        {steps.map((step, index) => (
          <div
            key={step.title}
            className="flex flex-col items-center text-center gap-2 p-3 bg-card border border-white/5"
            style={{ borderRadius: '2px' }}
          >
            <div className="relative">
              <div
                className="w-9 h-9 bg-primary/10 border border-primary/20 flex items-center justify-center"
                style={{ borderRadius: '2px' }}
              >
                <Icon name={step.icon as 'MapIcon'} size={18} variant="outline" className="text-primary" />
              </div>
              <span
                className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-primary text-white font-mono text-[9px] flex items-center justify-center"
                style={{ borderRadius: '1px' }}
              >
                {index + 1}
              </span>
            </div>
            <div>
              <p className="font-heading text-xs text-foreground uppercase tracking-wide leading-tight">
                {step.title}
              </p>
              <p className="font-body text-xs text-muted-foreground mt-1 leading-snug hidden md:block">
                {index === 0 ? (
                  step.description
                ) : (
                  step.description
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}